import { render, staticRenderFns } from "./DdDateBoxInside.vue?vue&type=template&id=59568e4a&scoped=true&"
import script from "./DdDateBoxInside.vue?vue&type=script&lang=js&"
export * from "./DdDateBoxInside.vue?vue&type=script&lang=js&"
import style0 from "./DdDateBoxInside.vue?vue&type=style&index=0&id=59568e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59568e4a",
  null
  
)

export default component.exports